angular.module('picmonicng').factory('SpacedRepSettingsModal', [
  '$modal',
  'SalesforceChatService',
  function ($modal, SalesforceChatService) {
    return {
      show: function (tab) {
        tab = tab ? tab : 'settings';

        return $modal.open({
          templateUrl: '/templates/modals/spaced-rep-settings.html',
          windowClass: 'spaced-rep-settings full-screen-modal',
          backdropClass: 'above-nav',
          size: 'md',
          controller: [
            '$scope',
            'UserService',
            'User',
            'toaster',
            '$window',
            '$timeout',
            function ($scope, UserService, User, toaster, $window, $timeout) {
              $scope.UserService = UserService;
              $scope.tab = tab;
              $scope.filter = 'today';
              $scope.spaced_rep_queue_max = UserService.user.settings.spaced_rep_queue_max;
              $scope.spaced_rep_round_max = UserService.user.settings.spaced_rep_round_max;
              $scope.spaced_rep_timezone = UserService.user.settings.timezone;
              $scope.timezones = moment.tz.names();

              $scope.getQueue = function () {
                if ($scope.loading) {
                  return;
                }

                $scope.loading = true;

                User.getv3(
                  { resource: 'spacedrep', resource_id: 'queue' },
                  function (result) {
                    $scope.queue = result;
                    $scope.loading = false;
                  },
                  function () {
                    $scope.loading = false;
                  }
                );
              };

              $scope.getQueue();

              if (!$scope.spaced_rep_timezone) {
                timezone = moment.tz.guess();
                $scope.spaced_rep_timezone = timezone;
                UserService.user.settings.timezone = timezone;
              }

              $scope.saveSettings = function () {
                if ($scope.spacedrepsettings.$invalid) {
                  return;
                }

                UserService.user.settings.spaced_rep_queue_max = $scope.spaced_rep_queue_max;
                UserService.user.settings.spaced_rep_round_max = $scope.spaced_rep_round_max;
                UserService.user.settings.timezone = $scope.spaced_rep_timezone;

                UserService.user.$update().then(function () {
                  $scope.$close();
                });
              };

              $scope.setTab = function (tab) {
                $scope.tab = tab;
              };

              $scope.setFilter = function (filter) {
                $scope.filter = filter;
              };

              $scope.seeMore = function (picmonic) {
                if ($scope.saving) {
                  return;
                }

                $scope.saving = true;

                User.updatev3(
                  {
                    resource: 'spacedrep',
                    resource_id: 'picmonic',
                    resource2: picmonic.card_id,
                    picmonic_factor: 0.75,
                  },
                  function () {
                    $scope.saving = false;
                    $scope.getQueue();
                    toaster.success(picmonic.name + ' will show up MORE often in your daily quiz.');
                  },
                  function () {
                    toaster.error('Error showing ' + picmonic.name + ' MORE.');
                    $scope.saving = false;
                  }
                );
              };

              $scope.seeLess = function (picmonic) {
                if ($scope.saving) {
                  return;
                }

                $scope.saving = true;

                User.updatev3(
                  {
                    resource: 'spacedrep',
                    resource_id: 'picmonic',
                    resource2: picmonic.card_id,
                    picmonic_factor: 1.25,
                  },
                  function () {
                    $scope.saving = false;
                    $scope.getQueue();
                    toaster.success(picmonic.name + ' will show up LESS often in your daily quiz.');
                  },
                  function () {
                    toaster.error('Error showing ' + picmonic.name + ' LESS');
                    $scope.saving = false;
                  }
                );
              };

              $scope.remove = function (picmonic) {
                if ($scope.saving) {
                  return;
                }

                if (!confirm('Are you sure you want to completely remove this Topic from your queue?')) {
                  return;
                }

                $scope.saving = true;

                User.deletev3(
                  {
                    resource: 'spacedrep',
                    resource_id: 'picmonic',
                    resource2: picmonic.card_id,
                  },
                  function () {
                    $scope.saving = false;
                    $scope.getQueue();
                    toaster.success(picmonic.name + ' has been removed from your daily quiz.');
                  },
                  function () {
                    toaster.error('Error removing ' + picmonic.name + ' from your daily quiz.');
                    $scope.saving = false;
                  }
                );
              };

              $scope.moveToToday = function (picmonic) {
                if ($scope.saving) {
                  return;
                }

                $scope.saving = true;

                User.savev3(
                  {
                    resource: 'spacedrep',
                    resource_id: 'picmonic',
                    resource2: picmonic.card_id,
                  },
                  function () {
                    $scope.saving = false;
                    $scope.getQueue();
                    toaster.success(picmonic.name + " has been moved to today's daily quiz queue.");
                  },
                  function () {
                    toaster.error('Error moving ' + picmonic.name + " to today's daily quiz queue.");
                    $scope.saving = false;
                  }
                );
              };

              $scope.showSalesforceChatMessage = function () {
                $scope.$close();
                $timeout(function () {
                  SalesforceChatService.startChat('I have feedback on the Daily Quiz Management Portal');
                });
              };
            },
          ],
        });
      },
    };
  },
]);
